import React from 'react'
import { Radio } from 'antd'

type PropTypes = {
  options: Array<{
    label?: string
    value: number | boolean | string
    renderLabel?: () => React.ReactNode
  }>
  onChange: (newState: number | boolean | string) => void
  value: number | boolean | string | undefined
}

export const RadioGroup = ({ value, onChange, options }: PropTypes) => (
  <Radio.Group value={value}>
    {options.map((option) => (
      <Radio
        // @ts-ignore
        className={
          value !== undefined && option.value !== value && 'radio-not-selected'
        }
        value={option.value}
        onClick={() => onChange(option.value)}
      >
        {option.renderLabel ? option.renderLabel() : option.label}
      </Radio>
    ))}
  </Radio.Group>
)

export default RadioGroup
